﻿import applyValidationMessages from "../utility/validation-messages";
import FormSubmissionEvent from "../datalayer/events/form-submission-event";
import DataLayerUser from "../datalayer/classes/datalayer-user";

let form = null;
export default {
    canInit: (selector) => {
        form = document.querySelector(selector);
        return form !== null;
    },
    init: () => {
        form.noValidate = true;
        form.addEventListener('submit', submitHandler);
    }
}

async function submitHandler(e) {
    e.preventDefault();

    applyValidationMessages(form);
    const isValid = form.reportValidity();

    pushDataLayer();

    if (!isValid) {
        const firstInvalid = form.querySelector(':invalid');

        if (firstInvalid) {
            firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstInvalid.focus();
        }

        return;
    }

    const button = form.querySelector('button[type="submit"]');
    const originalText = button.textContent;

    button.disabled = true;
    button.textContent = 'Subscribing...';

    try {
        const token = await new Promise(function (resolve, reject) {
            grecaptcha.ready(function () {
                grecaptcha.execute('6LfC6-4tAAAAAN_jz9ln87vRaN6dXGduLeluXwnU', { action: 'subscribe' })
                    .then(resolve)
                    .catch(reject);
            });
        });

        form.querySelector('#subscribeRecaptchaToken').value = token;

        const response = await fetch(form.action, {
            method: 'POST',
            body: new FormData(form),
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });

        if (!response.ok) {
            throw new Error(`Subscribe failed (status ${response.status})`);
        }

        field('email').value = '';
        form.querySelector('#subscribe-form-status').classList.toggle('d-none');
    } catch (error) {
        console.error(error);
    } finally {
        button.disabled = false;
        button.textContent = originalText;
    }
}

function pushDataLayer() {
    const errors = Array.from(form.elements)
        .filter(element => element.willValidate && !element.validity.valid)
        .map(element => ({
            message: element.validationMessage
        }));

    const dataLayerEvent = new FormSubmissionEvent('newsletter', errors, buildUser());
    dataLayerEvent.push();
}

function buildUser() {
    const dataLayerUser = new DataLayerUser();
    
    dataLayerUser.email = value('email');

    return dataLayerUser;
}

function value(name) {
    return field(name).value;
}

function field(name) {
    return form.querySelector(`[name=${name}]`);
}